
import * as navigate from 'app/area/shared/navigation';
import { ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';

export const changeCaseTypeActionCreator = (
  _, 
  uiEngineProps: ConnectedComponentProps
) => {  
  const {draftId} = uiEngineProps.hostProps();
  
  return {
    ...({
      onChangeCaseType: navigate.toSelectChangeCaseType(draftId)
    })
  };
};
